import { render, staticRenderFns } from "./Spider.vue?vue&type=template&id=fc9aa1f4"
import script from "./Spider.ts?vue&type=script&lang=js&external"
export * from "./Spider.ts?vue&type=script&lang=js&external"
import style0 from "./Spider.vue?vue&type=style&index=0&id=fc9aa1f4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports